import { getCustomTag, sendNotification, useApiClient, useTranslation } from '@msdk/common'
import {
  Entity,
  EntityMetadata,
  EntityModel,
  EntityOperation,
  OptionsetValue,
  readBaseMetadataByName,
  readEntityModelByName,
  ServerOperationResult,
} from '@msdk/definitions'
import { ButtonSecondary, styled } from '@msdk/ui'
import React from 'react'

import { messagesFromEntityOperation } from '../../utils'

const ActivateButtonStyled = styled(ButtonSecondary)`
  margin-right: 5px;
`

interface Props {
  selectedRows: Entity[]
  reload: () => void
}

export function ActivateButton(props: Props) {
  const t = useTranslation()
  const api = useApiClient()

  const handleClick = async () => {
    const promises: Promise<EntityOperation>[] = []
    props.selectedRows.forEach((row) => {
      const baseMetadata = readBaseMetadataByName(row.entityName) as EntityMetadata
      const model = readEntityModelByName(row.entityName) as EntityModel
      const toUpdate: Entity = {
        entityName: row.entityName,
        id: row.id,
        isPersisted: row.isPersisted,
        parentId: row.parentId,
        internalId: row.internalId,
        isInCreation: row.isInCreation,
        fields: {
          ENTITY_STATUS: new OptionsetValue('ACTIVE', 'ENTITY_STATUS'),
        },
      }

      if (model.extendedBy != null && model.extendedBy != '') {
        toUpdate.fields['EXTENDED_BY'] = row.fields['EXTENDED_BY']
        toUpdate.fields['EXTENDED_BY_PARENTID'] = row.fields['EXTENDED_BY_PARENTID']
      }

      const promise = api.entity.forceSaveEntities(baseMetadata.msProvider, model, [toUpdate])
      promises.push(promise)
    })

    const results = await Promise.all(promises)
    const failures = results.filter((r) => r.result == ServerOperationResult.Failure)
    if (failures.length) {
      failures.forEach((f) => {
        const serverMessages = messagesFromEntityOperation(f)
        if (serverMessages.length) {
          const translated = serverMessages.reduce((acc, curr) => (acc += `\n${t(curr.idml, curr.description)}`), '')
          sendNotification({ message: translated, status: 'error' })
        }
      })
    }

    props.reload()
  }

  return (
    <ActivateButtonStyled
      onClick={handleClick}
      key="ACTIVATE"
      disabled={props.selectedRows.length === 0}
      data-test-id={getCustomTag(['view', 'activate', 'button'])}
    >
      {t('CMPSR_ACTIVATE', 'Activate')}
    </ActivateButtonStyled>
  )
}
